// import $ from "jquery";
import uniqBy from "lodash/uniqBy";

import {IntermediatePart} from "../../intermediatePart";
import {BACKSPLASH_TYPES, LayoutAbbreviations} from "../../constants";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import Cabinet from "../../parts/cabinet";
import {loaderDisable, loaderEnable} from "../../../../ui/loaderView";
import Navigation from "../../../../visComponents/navigation/navigation";
// import ActionTypes from "../../../../../misc/actionTypes";

export default class Backsplash extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'backsplash';
    this.partName = 'Backsplash';
    this.translateId = "visualizer.kitchen.walls.backsplash";
    this.isStoneFeature = true;
    this.canBeDisabled = true;
    this.toggleSwitchedOffByUser = false;
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    if (Array.isArray(dbFeature.metaData["CabinetLayout"])
      && dbFeature.metaData["CabinetLayout"].includes("4")
      && !dbFeature.metaData["CabinetLayout"].includes("5")) {
      dbFeature.metaData["CabinetLayout"].push("5");
    }
    // if (!(Array.isArray(dbFeature.metaData["backsplashType"]) || Array.isArray(dbFeature.metaData["BacksplashType"]))) {
    //   if (dbFeature.description && dbFeature.description.includes("4in")) {
    //     dbFeature.metaData["BacksplashType"] = ["4in"];
    //   } else if (dbFeature.description && dbFeature.description.includes("6in")) {
    //     dbFeature.metaData["BacksplashType"] = ["6in"];
    //   } else if (dbFeature.metaData["CabinetLayout"]) {
    //     dbFeature.metaData["BacksplashType"] = ["18in"];
    //   }
    //   console.log("backsplash custom", dbFeature.sharedFeatureName, dbFeature.metaData["BacksplashType"]);
    // }
    return super.load_(dbFeature, new Backsplash());
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    if (this.activeFeature) {
      // const withInches = BACKSPLASH_TYPES.filter(bType => bType.includes("in"));
      // const filterByInchSize = withInches.find(bType => this.activeFeature.partName.includes(bType));
      featuresToDisplay = featuresToDisplay.filter(feature => {
        if (Array.isArray(this.activeFeature.metaData["BacksplashType"]) && Array.isArray(feature.metaData["BacksplashType"])) {
          return feature.metaData["BacksplashType"].includes(this.activeFeature.metaData["BacksplashType"][0])
        }
        return false
        // if (!feature.partName) {
        //   return false
        // }
        // return filterByInchSize
        //   ? feature.partName.includes(filterByInchSize)
        //   : withInches.every(withInchesType => !feature.partName.includes(withInchesType))
      }); // filter by 4in, 6in, Full

      if (this.featureIsFullWall(this.activeFeature)) { // full backsplashes should be filtered by CabinetLayout metaData
        const cabinetParent = this.getParent().layout.parts[Cabinet.id];
        const cabinetLayoutMetaData = cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
          && cabinetParent.topCabinet.activeFeature.metaData && cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"];
        if (cabinetLayoutMetaData) {
          featuresToDisplay = featuresToDisplay.filter(feature => feature.metaData && feature.metaData["CabinetLayout"]
            && feature.metaData["CabinetLayout"].includes(cabinetLayoutMetaData[0]))
        }
      }
    }

    return uniqBy(this.getUniqueFeatures(featuresToDisplay), (feature) => feature.dbFeature.id)
      .map(_ => new DesignNavigationItem(_.featureName, _));
  }

  getUniqueFeatures(featuresToDisplay) { // remove bathroom backsplashes (with the same name and not in visualizer)
    return featuresToDisplay.filter(feature => {
      const featureSplittedName = feature.getSplittedFeatureName();
      return !(feature.notAvailableInVisualizer && featuresToDisplay.some(countertop => {
        return countertop.getSplittedFeatureName() === featureSplittedName
      }));
    })
  }

  getFeatureByBacksplashType(neededType, featureName = "") {
    // const withInches = BACKSPLASH_TYPES.filter(bType => bType.includes("in"));
    const matchingFeatures = this.features.filter(feature => {
      if (Array.isArray(feature.metaData["BacksplashType"]) && feature.metaData["BacksplashType"].includes(neededType)) {
        return true
      }
      // return feature.partName && (withInches.includes(neededType)
      //   ? feature.partName.includes(" "+neededType)
      //   : withInches.every(withInchesType => !feature.partName.includes(withInchesType)))
    });

    let currentPartName = featureName;
    if (!currentPartName && this.activeFeature) {
      // currentPartName = this.activeFeature.removeLayoutFromPartName(this.activeFeature.partName); // remove layout name
      // withInches.forEach(bType => currentPartName = currentPartName.split(" "+bType).join("")); // 2) remove 6in or 4in
      // currentPartName = this.activeFeature.removeCabinetLayoutFromPartName(currentPartName);
      currentPartName = this.activeFeature.getCountertopGroupsSplittedFeatureName();
    }

    const matchByName = matchingFeatures.filter(feature => {
      // let featurePartName = feature.removeLayoutFromPartName(feature.partName);  // remove layout name
      // withInches.forEach(bType => featurePartName = featurePartName.split(" "+bType).join("")); // 2) remove 6in or 4in
      // featurePartName = feature.removeCabinetLayoutFromPartName(featurePartName);
      return feature.getCountertopGroupsSplittedFeatureName() === currentPartName
    });
    if (matchByName.length > 1) {
      const cabinetLayoutMetaData = this.getTopCabinetCabinetLayoutMetadata();
      const sameCabinetType = matchByName.find(feature => {
        if (this.featureIsFullWall(feature)) {
          return feature.matchesMetaForArrayOfConditions([
            {
              propName: 'CabinetLayout',
              propValue: cabinetLayoutMetaData
            }
          ])
        }
      });
      return sameCabinetType || matchByName[0];
    }
    return matchByName[0] || matchingFeatures[0];
  }

  featureIsFullWall = (feature) => {
    // const withInches = BACKSPLASH_TYPES.filter(bType => bType.includes("in"));
    // return !withInches.some(bType => feature.partName.includes(bType))
    //   || (Array.isArray(feature.metaData["BacksplashType"]) && feature.metaData["BacksplashType"][0] === "18in");
    return Array.isArray(feature.metaData["BacksplashType"]) && feature.metaData["BacksplashType"][0] === "18in"
  }

  getCurrentActiveFeatureType() {
    if (this.activeFeature && Array.isArray(this.activeFeature.metaData["BacksplashType"])) {
      return this.activeFeature.metaData["BacksplashType"][0]
    }
    return "18in"
    // const withInches = BACKSPLASH_TYPES.filter(bType => bType.includes("in"));
    // return this.activeFeature && (withInches.find(bType => {
    //   return this.activeFeature.partName.includes(bType)
    // }) || BACKSPLASH_TYPES[2])
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  setDefault() {
    const filteredFeatures = this.getArrayOfConditions
      ? this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))
      : this.features;
    const matchingFeatureExist = this.tryToSetTheSameFeature(filteredFeatures, null);
    if (!matchingFeatureExist && !window.requestInProcess) {
      this.activeFeature = filteredFeatures[0];
    }
    if (this.setActiveFeatureParts) {
      this.activeFeatureParts = this.setActiveFeatureParts();
    }
  }

  tryToSetTheSameFeature(filteredFeatures = [], partName = "") {
    if (this.activeFeature && this.activeFeature.partName) {
      this.activeFeature = this.findFeatureByPartName(
        partName || this.activeFeature.getCountertopGroupsSplittedFeatureName(),
        !partName,
        filteredFeatures
      );
      if (this.activeFeature) {
        return true
      }
    }
    return false
  }

  findFeatureByPartName(splittedName, alReadySplitted = true) {
    if (!alReadySplitted) {
      splittedName = this.removeLayoutFromPartName(splittedName);
      splittedName = this.removeCabinetLayoutFromPartName(splittedName);
    }
    const navFeature = this.navigationSubItems().find((feature) => {
      if (feature.part && feature.part.partName) {
        let currentFeatureSplittedName = feature.part.getCountertopGroupsSplittedFeatureName();
        return currentFeatureSplittedName === splittedName
      }
    });
    return navFeature && navFeature.part
  }

  setFeatureByName = async (passedName = "") => {
    window.requestInProcess = true;
    loaderEnable();
    const splittedName = passedName || this.activeFeature.getCountertopGroupsSplittedFeatureName();
    await Navigation.searchFeaturesByName(this, splittedName);
    const neededFeature = this.findFeatureByPartName(splittedName, true);
    if (neededFeature) {
      this.activeFeature = neededFeature;
    }
    window.requestInProcess = false;
    loaderDisable();
    // $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
    return true
  };

  getTopCabinetCabinetLayoutMetadata() {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    return cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
      && cabinetParent.topCabinet.activeFeature.metaData && cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"];
  }

  getArrayOfConditions() {

    const conditions = [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];

    const cabinetLayoutMetaData = this.getTopCabinetCabinetLayoutMetadata();

    if (cabinetLayoutMetaData && this.activeFeature) {
      if (this.featureIsFullWall(this.activeFeature)) {
        conditions.push({
          propName: 'CabinetLayout',
          propValue: cabinetLayoutMetaData
        });
      }
    }
    return conditions;
  }

  removeBacksplashTypeFromPartName(partName) {
    BACKSPLASH_TYPES.forEach(abbr => {
      partName = partName.replace(" "+abbr, "")
    });
    return partName
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Walls.Backsplash;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }

  canUseNavigationFilterSteps() {
    return true
  }

}
